export default __webpack_public_path__ + "static/media/facebook.538495b1.svg";